import { useState } from 'react'
import { addDays, startOfDay } from 'date-fns'
import { Calendar as CalendarIcon, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

interface SchedulePublishPickerProps {
  onSchedule: (date: string) => void
  isPending: boolean
}

export function SchedulePublishPicker({ onSchedule, isPending }: SchedulePublishPickerProps) {
  const [date, setDate] = useState<Date | undefined>(undefined)
  const [open, setOpen] = useState(false)
  const minDate = addDays(startOfDay(new Date()), 1)

  const handleSelect = (selectedDate: Date | undefined) => {
    setDate(selectedDate)
    if (selectedDate) {
      onSchedule(selectedDate.toISOString())
      setOpen(false)
      setDate(undefined)
    }
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" disabled={isPending}>
          {isPending ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <CalendarIcon className="mr-2 h-4 w-4" />
          )}
          Schedule Publish
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleSelect}
          disabled={(d) => d < minDate}
          aria-label="Schedule publish date"
          autoFocus
        />
      </PopoverContent>
    </Popover>
  )
}
